import { ExternalLink, Landmark } from "lucide-react";
import { useLang } from "../../i18n/LanguageContext";
import { Reveal, Overline } from "./Reveal";

export const ItalySection = () => {
  const { t } = useLang();
  const it = t.italy;

  return (
    <section id="italy" data-testid="italy-section" className="bg-white py-28 lg:py-36 border-t border-slate-200">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <Reveal>
          <Overline>{it.overline}</Overline>
          <h2 className="mt-6 font-serif text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-tight text-slate-900 max-w-2xl">
            {it.title}
          </h2>
          <p className="mt-5 text-base md:text-lg text-slate-600 leading-relaxed max-w-2xl">{it.lead}</p>
        </Reveal>

        <div className="mt-16 grid lg:grid-cols-[0.9fr_1.1fr] gap-px bg-slate-200 border border-slate-200">
          <Reveal className="h-full">
            <div data-testid="italy-register-card" className="bg-[#FAF9F6] h-full p-8 lg:p-10">
              <div className="flex items-center gap-3">
                <Landmark size={18} strokeWidth={1.6} className="text-emerald-700" />
                <h3 className="text-base font-medium text-slate-900">{it.cardTitle}</h3>
              </div>
              <div className="mt-7 space-y-5">
                {it.fields.map(([k, v]) => (
                  <div key={k} className="flex flex-col gap-1 pb-4 border-b border-slate-200 last:border-0 last:pb-0">
                    <span className="text-[10px] font-mono uppercase tracking-[0.18em] text-slate-500">{k}</span>
                    <span className="text-sm text-slate-900">{v}</span>
                  </div>
                ))}
              </div>
              <a
                data-testid="consob-verify-link"
                href="https://www.consob.it/web/area-pubblica/imprese-investimento-senza-succursale#impresa-ue-senza-succursale-82:~:text=Impresa%20di%20investimento%3A-,ASTEO%20LUXEMBOURG%20S.A.,-Sede%20legale%3A"
                target="_blank"
                rel="noopener noreferrer"
                className="mt-8 inline-flex items-center gap-2 text-sm text-emerald-700 hover:text-emerald-900 transition-colors duration-300"
              >
                {it.verify} <ExternalLink size={13} />
              </a>
            </div>
          </Reveal>

          <Reveal delay={0.1} className="h-full">
            <div data-testid="italy-services-list" className="bg-white h-full p-8 lg:p-10">
              <span className="text-[10px] font-mono uppercase tracking-[0.2em] text-slate-500">{it.servicesTitle}</span>
              <div className="mt-7">
                {it.services.map((s, i) => (
                  <div
                    key={i}
                    data-testid={`italy-service-${i}`}
                    className="group flex gap-6 py-5 border-b border-slate-100 last:border-0"
                  >
                    <span className="font-mono text-xs text-emerald-700 pt-1 shrink-0">{String(i + 1).padStart(2, "0")}</span>
                    <p className="text-sm md:text-base text-slate-700 leading-relaxed group-hover:text-slate-900 transition-colors duration-300">
                      {s}
                    </p>
                  </div>
                ))}
              </div>
              <p className="mt-7 text-xs text-slate-500 leading-relaxed">{it.note}</p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
